import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import CategoryCard from '@/components/base/CategoryCard';
import { categories, siteConfig } from '@/mocks/site';

export default function Categories() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '兴趣分类 - 撸撸社',
    description: '浏览撸撸社全部兴趣分类，包括手工DIY、摄影艺术、美食烹饪、运动健身、阅读写作、游戏电竞、旅行探索、音乐之声等领域',
    url: `${siteConfig.url}/categories`,
    isPartOf: {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: siteConfig.url },
      { '@type': 'ListItem', position: 2, name: '分类浏览' },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-24 pb-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-1.5 text-sm mb-8" aria-label="面包屑导航">
              <a href="/" className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">首页</a>
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              <span className="text-foreground-800 font-medium whitespace-nowrap">分类浏览</span>
            </nav>

            <div className="mb-10">
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
                探索兴趣分类
              </h1>
              <p className="text-sm md:text-base text-foreground-600">
                八大兴趣领域，{siteConfig.articleCount.toLocaleString()}+ 篇优质文章，总有一个属于你的天地
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {categories.map((cat) => (
                <CategoryCard
                  key={cat.slug}
                  slug={cat.slug}
                  name={cat.name}
                  icon={cat.icon}
                  description={cat.description}
                  articleCount={cat.articleCount}
                  color={cat.color}
                  imageUrl={cat.imageUrl}
                />
              ))}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}